<!-- 雇员清单 -->
<template>
  <div>
    <a-row :gutter="24">
      <div id="start" class="title_">
        <div class="cutleft_">添加雇员清单</div>
        <div class="cutoff_"></div>
      </div>
      <div class="btn-top-box">
        <div></div>
        <div>
          <a @click="$tools.downloadFile(fileCodeContent.emp_url)" class="btn_a">点击下载被保险人批量导入excel文件模版</a>
          <a-upload name="file" :multiple="true" action="/api/file/guofou/parseInsuredExcel" @change="handleFileChange">
            <a-button type="primary" icon="upload" :disabled='disabledAll'
              :style="disabledAll?'color:#ccc;border: 1px solid #ddd;':''"> 批量上传 </a-button>
          </a-upload>
        </div>
      </div>
      <div class="table-box">
        <a-table :pagination="false" :row-selection="{
            selectedRowKeys: selectedRowKeys,
            onChange: onSelectChange,
          }" :columns="columns" :data-source="data" :scroll="{ x: 1600 }">
          <span slot="num" slot-scope="text, records, index">
            {{Number(index) + 1 }}
          </span>
          <span slot="idType" slot-scope="idType">{{ IDTYPE(idType) }}</span>
          <span slot="occulevel" slot-scope="occulevel">{{ handocculevel(occulevel) }}</span>
          <span slot="gender" slot-scope="gender">{{
            gender == "M" || gender == "男" ? "男" : "女"
          }}</span>
        </a-table>
      </div>
      <div class="flex justify-cneter btn-box">
        <a-button icon="edit" @click="editPreson" :disabled='disabledAll'
          :style="disabledAll?'color:#ccc;border: 1px solid #ddd;':''"> 修改被保人 </a-button>
        <a-button icon="delete" @click="delTele" :disabled='disabledAll'
          :style="disabledAll?'color:#ccc;border: 1px solid #ddd;':''"> 批量删除 </a-button>
        <a-button icon="copy" @click="visibleStick = true" :disabled='disabledAll'
          :style="disabledAll?'color:#ccc;border: 1px solid #ddd;':''"> 粘贴名单 </a-button>
        <a-button icon="plus" @click="addGuyuan" :disabled='disabledAll'
          :style="disabledAll?'color:#ccc;border: 1px solid #ddd;':''"> 新增人员 </a-button>
        <div class="baoxian-num">被保险人共：{{data&&data.length}}人</div>

      </div>
    </a-row>
    <!-- 粘贴名单 -->
    <a-modal class="myModal_" width="1021px" title="粘贴名单数据" forceRender v-model="visibleStick" @ok="handleStick"
      okText="确定" cancelText="关闭">
      <div class="flex_">
        <span :style="{ color: 'red' }">*</span>
        <div style="display: inline-block">
          字段与字段直接用空格隔开，时间格式支持2018-01-01或2018/01/01。<font color="red">（切记每一项文本之间不能有空格，多个请用换行符（回车）分割。）</font>
        </div>
        <div style="margin-bottom: 8px; padding-left: 6px">
          例如：AA 身份证 110101199503076153 1990-01-01 女 1010001 中国共产党中央委员会和地方各级党组织负责人 1
        </div>
      </div>
      <textarea v-model="stickData" name="stickArea" id="stickArea" cols="30" rows="12"
        :style="{ width: '100%' }"></textarea>
    </a-modal>
    <!-- 新增雇员信息 -->
    <a-modal width="1021px" title="新增雇员信息" forceRender v-model="addShow" @ok="handleSubmitNew" okText="确定"
      cancelText="关闭">
      <div class="list">
        <a-form layout="horizontal" class="horizontal_item_" :form="form" @submit="handleSubmitNew">
          <a-row>
            <a-col :span="10">
              <a-form-item :label-col="{ span: 8 }" label="姓名">
                <a-input v-decorator="[
                    'addInsured.name',
                    {
                      rules: [{ required: true, message: '请输入姓名' }],
                      initialValue: addInsured.name,
                    },
                  ]" placeholder="请输入姓名"></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="10">
              <a-form-item :label-col="{ span: 8 }" label="国籍">
                <a-select @change="idTypeChange" placeholder="请选择" disabled v-decorator="[
                    'addInsured.nationality',
                    {
                      rules: [{ required: true, message: '请选择国籍' }],
                      initialValue: addInsured.nationality,
                    },
                  ]">
                  <a-select-option value="CHN">中国</a-select-option>
                  <a-select-option value="XXX">其他</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="10" class="mg_left_20">
              <a-form-item :label-col="{ span: 8 }" label="证件类型">
                <a-select @change="idTypeChange" placeholder="请选择" v-decorator="[
                    'addInsured.idType',
                    {
                      rules: [{ required: true, message: '请选择证件类型' }],
                      initialValue: addInsured.idType,
                    },
                  ]">
                  <a-select-option v-for="item in IdTypeOptions" :key="item.value" :value="item.value">{{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="10">
              <a-form-item :label-col="{ span: 8 }" label="证件号码">
                <a-input @blur="idNumberChange" v-decorator="[
                    'addInsured.idNumber',
                    {
                      rules: [{ required: true, message: '请输入证件号码' }],
                      initialValue: addInsured.idNumber,
                    },
                  ]" placeholder="请输入证件号码"></a-input>
              </a-form-item>
            </a-col>

            <a-col :span="10" class="mg_left_20">
              <a-form-item :label-col="{ span: 8 }" label="性别">
                <a-select placeholder="请选择" v-decorator="[
                    'addInsured.gender',
                    {
                      rules: [{ required: true, message: '请选择性别' }],
                      initialValue: addInsured.gender,
                    },
                  ]">
                  <a-select-option v-for="item in sexOptions" :key="item.value" :value="item.value">{{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="10" class="mg_left_20">
              <a-form-item :label-col="{ span: 8 }" label="出生日期">
                <a-date-picker v-decorator="[
                    'addInsured.birthDate',
                    {
                      rules: [{ required: true, message: '请选择出生日期' }],
                      initialValue: addInsured.birthDate,
                    },
                  ]" placeholder="请选择出生日期" />
              </a-form-item>
            </a-col>
            <a-col :span="10" class="mg_left_20">
              <a-form-item :label-col="{ span: 8 }" label="职业类别">
                <a-select placeholder="请选择" @change="occulevelChange" v-decorator="[
                    'addInsured.occulevel',
                    {
                      rules: [{ required: true, message: '请选择职业类别' }],
                      initialValue: addInsured.occulevel,
                    },
                  ]">
                  <a-select-option v-for="item in occupationOptionsLevel" :key="item.value" :value="item.value">
                    {{ item.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-form-item :label-col="{ span: 3 }" label="职业名称">
                <a-cascader ref="occupation" @change="occupationChange" v-decorator="[
                    'addInsured.occupation',
                    {
                      rules: [{ required: true, message: '请选择职业名称' }],
                      initialValue: addInsured.occupation,
                    },
                  ]" :options="occurOptions" :fieldNames="{
                    label: 'text',
                    value: 'value',
                    children: 'children',
                  }" placeholder="Please select" />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </a-modal>
    <a-modal v-model="filterShow" title="不合格投保人" :closable="false">
      <template slot="footer">
        <a-button key="submit" type="primary" @click="hideModal">
          确认
        </a-button>
      </template>
      <p v-for="(item, index) in filterArray" :key="index" v-html="item"></p>
    </a-modal>
  </div>
</template>

<script>
  //这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  //例如：import 《组件名称》 from '《组件路径》';
  // import dictOptions from "@/views/dictOptions";
  import { salInsuredListMixins } from '@/mixins/salInsuredListMixins.js';
  import utils from "../js/utils";
  import moment from "moment";
  let gahxReg = /^(M|H)\d{8,11}$/;//港澳回乡证
  let tbzReg = /^\d{8}$/;//台胞证
  let idNoReg = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X|x)$/;
  export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    mixins: [salInsuredListMixins],
    data() {
      //这里存放数据
      return {
        filterShow: false,
        filterArray: [], //被过滤的数组
        addBol: true,
        selectedRowKeys: [], //选中的人员
        visibleStick: false, //粘贴名单
        stickData: "", //粘贴的内容
        addShow: false, //新增雇员信息的弹窗
        idTypeBol: false,
        addInsured: {
          name: "", //姓名
          idType: "", //证件类别
          idNumber: "", //证件号码
          birthDate: null, //出生日期
          gender: "", //性别
          occupation: [],
          nationality:"CHN",
          occulevel: "", //职业类别
          occupationCode: "", //职业类别代码
          occupationName: "", //职业类别名称
        },
        sexOptions: utils.sexOptions,
        IdTypeOptions: [
          {
            value: '01',
            name: '身份证'
          },
        ],
        occupationOptionsLevel: utils.occupationOptionsLevel,//职业分类
        minAge: moment().subtract(16, "years"),
        form: this.$form.createForm(this, { name: "time_related_controls" }),
      };
    },
    props: ["data", "columns"],    //监听属性 类似于data概念
    computed: {
      occurOptions() {
        let occulevel = this.addInsured.occulevel.toString().indexOf('类') > -1 ? this.addInsured.occulevel.toString().slice(0, 1) : this.addInsured.occulevel.toString();
        var arr = this.$lodash.cloneDeep(this.fileCodeContent.level_tree);
        if (occulevel) {
          arr.forEach(element => {
            element.children.forEach(elem => {
              elem.children = elem.children.filter(
                item => item.occulevel == occulevel
              );
            });
          });
          arr.forEach(element => {
            element.children = element.children.filter(
              item => item.children.length > 0
            );
          });
          arr = arr.filter(item => item.children.length > 0);
        }
        return arr;
      },
    },
    //监控data中的数据变化
    watch: {
      filterArray(val) {
        this.filterShow = val.length > 0;
      },
    },
    //方法集合
    methods: {
      moment,
      idTypeChange(value) {
        this.idTypeBol = value == '01' ? true : false
      },
      hideModal() {
        this.filterShow = false;
        this.filterArray = [];
      },
      reactdata() {
        this.addInsured = {
          name: "", //姓名
          idType: "", //证件类别
          nationality:"CHN",
          idNumber: "", //证件号码
          birthDate: null, //出生日期
          gender: "", //性别
          occupation: [],
          occulevel: "", //职业类别
          occupationCode: "", //职业类别代码
          occupationName: "", //职业类别名称
        };
      },
      filter(inputValue, path) {
        //联动选择
        return path.some(
          (option) =>
            option.text.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
        );
      },
      idNumberChange(e) {
        let val = e.target.value;
        let gender, birthDate;
        if (idNoReg.test(val)) {
          if (val.slice(16, 17) % 2 == 1) {
            gender = "M";
          } else {
            gender = "F";
          }
          birthDate =
            val.slice(6, 10) + "-" + val.slice(10, 12) + "-" + val.slice(12, 14);
          this.form.setFieldsValue({
            addInsured: {
              birthDate: birthDate,
            },
          });
          this.form.setFieldsValue({
            addInsured: {
              gender: gender,
            },
          });
        }
      },
      IDTYPE(type) {
        if (!parseInt(type)) {
          return type;
        } else {
          var a = parseInt(type);
          switch (a) {
            case 1:
              return "身份证";
            case 2:
              return "护照";
            case 6:
              return "港澳回乡证或台胞证";
            case 99:
              return "其它";
            default:
              return type;
          }
        }
      },

      handocculevel(data) {
        let str = data.toString()
        if (str.indexOf('类') > -1) {
          return str
        } else {
          return str + '类'
        }
      },
      //职业类别
      occulevelChange(value) {
        this.addInsured.occulevel = value;
        this.form.setFieldsValue({
          addInsured: {
            occupationName: "",
            occupation: []
          }
        });
      },
      //限制生日的选项
      disabledDate(current) {
        const minAge = moment().subtract(16, "years");
        const maxAge = moment().subtract(65, "years");
        return current && (current > minAge || current < maxAge);
      },
      //确定雇员信息
      handleSubmitNew(e) {
        e.preventDefault();
        this.form.validateFields((err, values) => {
          let index = this.data.length;
          if (!err) {
            if (!this.$regTest.checkIdCard(values.addInsured.idNumber) && values.addInsured.idType == '01') {
              this.$message.error(`被保人证件号码不合法!`, 3);
              return;
            }
            if (values.addInsured.idType == '06') {
              if (values.addInsured.idNumber && values.addInsured.idNumber.length > 8) {//港澳回乡证
                if (!gahxReg.test(values.addInsured.idNumber)) {
                  this.$message.error(`被保人港澳回乡证号码不合法!`, 3);
                  return;
                }
              } else {
                if (!tbzReg.test(values.addInsured.idNumber)) {
                  this.$message.error(`被保人台胞证号码不合法!`, 3);
                  return;
                }
              }
            }
            let sign = this.data.filter(
              (item) => item.idNumber === values.addInsured.idNumber
            );
            if (!this.addBol) {//修改
              var signIndex = this.addInsured.index;
              let obj = {
                ...values.addInsured,
                index: signIndex,
                occulevel: values.addInsured.occulevel,
                birthDate: moment(values.addInsured.birthDate).format(
                  "YYYY-MM-DD"
                ),
                occupationName: this.filterName(values.addInsured.occupation),
                occupationCode: values.addInsured.occupation[2],
                eduitIndex: this.selectedRowKeys[0]
              };

              let age = moment().diff(obj.birthDate, "years");
              if (age < 16 || age > 65) {
                this.$message.error("投保人年龄仅限于16-65周岁，请修改后再试！");
                return;
              }

              this.$emit("EduitSelect", obj);
              this.addShow = false;
            } else {
              //添加
              if (sign.length > 0) {
                this.$message.error("被保人证件号码重复");
                return;
              }
              var obj = {
                ...values.addInsured,
                index: index,
                occulevel: values.addInsured.occulevel,
                birthDate: moment(values.addInsured.birthDate).format(
                  "YYYY-MM-DD"
                ),
                occupationName: this.filterName(values.addInsured.occupation),
                occupationCode: values.addInsured.occupation[2],
              };
              let age = moment().diff(obj.birthDate, "years");
              if (age < 16 || age > 65) {
                this.$message.error("投保人年龄仅限于16-65周岁，请修改后再试！");
                return;
              }
              this.$emit("addSelect", obj);
              this.addShow = false;
            }
          }
        });
      },
      //新增雇员信息
      addGuyuan() {
        this.addBol = true;
        this.addShow = true;
        this.reactdata();
        this.form.resetFields();
      },
      onSelectChange(selectedRowKeys) {
        this.selectedRowKeys = selectedRowKeys;
      },
      editPreson() {
        this.reactdata();
        //修改被保人
        this.addBol = false;
        if (this.selectedRowKeys.length !== 1) {
          this.$message.error("请选择要修改的被保人");
          return;
        }
        this.addShow = true;
        // console.log(this.selectedRowKeys);
        var eduitobj = this.$lodash.cloneDeep(this.data[this.selectedRowKeys[0]]);
        eduitobj.idType = utils.filterAllINTYPE(eduitobj.idType)
        eduitobj.occupationName = this.filterName([
          eduitobj.occupationCode.substring(0, 3),
          eduitobj.occupationCode.substring(0, 5),
          eduitobj.occupationCode,
        ]);
        if (!eduitobj.occupation) {
          eduitobj.occupation = [
            eduitobj.occupationCode.substring(0, 3),
            eduitobj.occupationCode.substring(0, 5),
            eduitobj.occupationCode,
          ]
        } //职业类别代码
        eduitobj.occulevel = eduitobj.occulevel - 0
        this.form.setFieldsValue({
          addInsured: {
            ...eduitobj,
          }
        });
      },
      //批量删除
      delTele() {
        if (!this.selectedRowKeys.length) {
          this.$message.error("请选择要删除的被保人");
          return;
        }
        // 删除被保人
        let cusData = this.$lodash.cloneDeep(this.data);
        let filter = cusData.filter((item, index) => {
          return this.selectedRowKeys.indexOf(index) < 0;
        });
        cusData = filter;
        this.$emit("delSelect", cusData);
        this.selectedRowKeys = [];
      },
      //粘贴
      handleStick() {
        if (!this.stickData) {
          this.$message.error("您还没有任何输入！");
          return;
        }
        var allArr = this.stickData
          .replace(/\n/g, "#")
          .split("#")
          .filter((e) => e != "");
        allArr.forEach((e) => {
          let arr = e.trim().split(/\s+/g);
          let obj = {};
          let code = this.occCode.allCode;
          if (code.indexOf(arr[5]) <= -1) {
            this.filterArray.push(
              `被保人“${arr[0]}”身份证为“${arr[2]}”的行业code为<font color="red">${arr[5]}</font>不存在，请检查后重新上传！`
            );
            return;
          }
          if (!this.$regTest.checkIdCard(arr[2]) && arr[1] == '身份证') {
            this.filterArray.push(
              `被保人“${arr[0]}”身份证为“${arr[2]}”的身份证有误，请检查后重新上传！`
            );
            return;
          }
          if (arr[1] == '港澳回乡证' || arr[1] == '台胞证' || arr[1] == '港澳回乡证或台胞证') {
            if (arr[2] && arr[2].length > 8) {//港澳回乡证
              if (!gahxReg.test(arr[2])) {
                this.$message.error(`被保人港澳回乡证号码不合法!`, 3);
                return;
              }
            } else {
              if (!tbzReg.test(arr[2])) {
                this.$message.error(`被保人台胞证号码不合法!`, 3);
                return;
              }
            }
          }
          let refuseCode = this.occCode.refuseCode;
          if (refuseCode.indexOf(arr[5]) > -1) {
            this.filterArray.push(
              `被保人“${arr[0]}”身份证为“${arr[2]}”的行业code为<font color="red">${arr[5]}</font>是拒保行业，请检查后重新上传！`
            );
            return;
          }
          let age = moment().diff(arr[3], "years");
          if (age < 16 || age > 65) {
            this.filterArray.push(
              `被保人“${arr[0]}”身份证为“${arr[2]}”的年龄为<font color="red">${age}</font>，不在16-65周岁之间，请检查后重新上传！`
            );
            return;
          }
          arr[6] = this.filterName([
            arr[5].substring(0, 3),
            arr[5].substring(0, 5),
            arr[5],
          ])
          this.columns.forEach((e, i) => {
            obj[e.dataIndex] = arr[i];
            obj["occulevel"] = arr[arr.length - 1];
          });
          console.log(obj);
          obj.idType = utils.filterAllINTYPE(obj.idType)
          this.$emit("addSelect", obj);
        });
        this.stickData = "";
        this.visibleStick = false;
      },
      occupationChange(value) { //选择职业名称带出职业类别
        let oneArr = this.fileCodeContent.level_tree.filter((item) => item.value == value[0]) || [];
        let twoArr = oneArr[0].children.filter((item) => item.value == value[1]) || [];
        let threeArr = twoArr[0].children.filter((item) => item.value == value[2]) || [];
        this.form.setFieldsValue({
          addInsured: {
            occulevel: threeArr[0].occulevel - 0
          }
        })
      },
      //批量上传
      handleFileChange(info) {
        if (info.file.status === "done") {
          let length = this.data.length;
          let newArr = [];
          let hasInvalidIdCard = false;
          info.file.response.content.forEach((item, index) => {
            let obj = {
              index: index + length + 1,
              idType: item.insIdType == "身份证" ? "1" : "2",
              idNumber: item.insIdNumber,
              gender: this.filterSex(item.insGender),
              mobile: item.phone,
              birthDate: item.insBirthday, //生日
              relationship: 11, //与投保人关系
              height: 11, //与主被保人关系 同上
              name: item.insName,
              nationality:"CHN", //国籍
              occulevel: item.occulevel, //职业大类
              occupation: [
                item.occupationCode.substring(0, 1),
                item.occupationCode.substring(0, 3),
                item.occupationCode.substring(0, 5),
                item.occupationCode,
              ], //职业类别代码
              occupationCode: item.occupationCode, //职业类别代码
              uniqueid: "", //被保人保额
              premium: "", //被保人保费
              occupationName: this.filterName([
                item.occupationCode.substring(0, 1),
                item.occupationCode.substring(0, 3),
                item.occupationCode.substring(0, 5),
                item.occupationCode,
              ]), //职业类别名称
              type: "C", // 固定值
            };
            if (!this.$regTest.checkIdCard(obj.idNumber)) {
              hasInvalidIdCard = true;
            }
            let currentTime = new Date(); //自定义时间
            var customTime = item.insInvalidate;
            customTime = new Date(Date.parse(customTime));
            if (currentTime.getTime() - customTime.getTime() > 0) {
              this.$message.error(`被保人证件有效期不合法!`, 3);
              return;
            }
            if (moment().diff(item.insBirthday, "years") < 18 || moment().diff(item.insBirthday, "years") > 65) {
              this.$message.error(
                `${item.insName} 年龄少于18岁或大于65岁，不能参与投保，请修改后再试！`
              );
              return;
            }
            if (hasInvalidIdCard) {
              this.$message.error("有被保险人身份证输入有误，请修改！", 6);
              return;
            }
            newArr.push(obj);
          });
          this.$emit("addSelect", newArr)
        } else if (info.file.status === "error") {
          this.$message.error(`${info.file.name} 文件导入失败，请重试！`);
        }
      },
      filterName(arr) {
        let codeName = this.$tools.filterName(this.fileCodeContent.level_tree, arr[arr.length - 1])
        return codeName;
      },
      filterSex(val) {
        //性别过滤
        return val == "男" ? "M" : "F";
      },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
      this.$bus.$on("busUserBol", () => {
        this.userBol = false;
        this.disabledAll = false;
      });
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
  };
</script>
<style scoped>
  .btn-box {
    margin: 20px 0;
  }

  .btn-box button {
    margin: 0 20px;
    border: 1px solid #fe8f2d;
    color: #fe8f2d;
  }

  .btn-top-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .btn-top-box button {
    margin: 0 0 10px 20px;
    border: 1px solid #fe8f2d;
    color: #fff;
  }

  .baoxian-num {
    font-size: 16px;
    font-weight: bold;
  }
</style>